import { render, staticRenderFns } from "./app-header-tablet-menu.vue?vue&type=template&id=5172b2ff&"
import script from "./app-header-tablet-menu.vue?vue&type=script&lang=js&"
export * from "./app-header-tablet-menu.vue?vue&type=script&lang=js&"
import style0 from "./app-header-tablet-menu.vue?vue&type=style&index=0&id=5172b2ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports